module.exports = [
  {
    'featureType': 'all',
    'elementType': 'labels',
    'stylers': [{ 'visibility': 'off' }]
  },
  {
    'featureType': 'administrative',
    'elementType': 'all',
    'stylers': [{ 'visibility': 'off' }]
  },
  {
    'featureType': 'administrative',
    'elementType': 'geometry',
    'stylers': [{ 'color': '#ff0000' }]
  },
  {
    'featureType': 'administrative',
    'elementType': 'labels.text.fill',
    'stylers': [{ 'color': '#444444' }]
  },
  {
    'featureType': 'landscape',
    'elementType': 'all',
    'stylers': [{ 'color': '#f2f2f2' }]
  },
  {
    'featureType': 'landscape',
    'elementType': 'geometry',
    'stylers': [{ 'color': '#ffffff' }]
  },
  {
    'featureType': 'poi',
    'elementType': 'all',
    'stylers': [{ 'visibility': 'off' }]
  },
  {
    'featureType': 'road',
    'elementType': 'all',
    'stylers': [{ 'saturation': -100 },
    { 'lightness': 45 },
    { 'visibility': 'simplified' }]
  },
  {
    'featureType': 'road',
    'elementType': 'geometry.fill',
    'stylers': [
      { 'visibility': 'on' },
      { 'color': '#434343' }
    ]
  },
  {
    'featureType': 'road',
    'elementType': 'labels',
    'stylers': [{ 'visibility': 'off' }]
  },
  {
    'featureType': 'road.highway',
    'elementType': 'all',
    'stylers': [{ 'visibility': 'simplified' }]
  },
  {
    'featureType': 'road.highway',
    'elementType': 'geometry.fill',
    'stylers': [{ 'color': '#454545' }]
  },
  {
    'featureType': 'road.highway',
    'elementType': 'labels',
    'stylers': [{ 'visibility': 'off' }]
  },
  {
    'featureType': 'road.arterial',
    'elementType': 'labels.icon',
    'stylers': [{ 'visibility': 'off' }]
  },
  {
    'featureType': 'transit',
    'elementType': 'all',
    'stylers': [{ 'visibility': 'off' }]
  },
  {
    'featureType': 'water',
    'elementType': 'all',
    'stylers': [
      { 'color': '#222222' },
      { 'visibility': 'on' }
    ]
  }
];
